// extracted by css-extract-rspack-plugin
export default {"fileFieldWrapper":"NBZC4hKOnog2nuo3","rule":"KCJpd9BGa8ItCQi4"};